import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "about",
  class: "section-container"
}
const _hoisted_2 = { class: "section-content" }
const _hoisted_3 = { class: "media-top" }
const _hoisted_4 = { class: "media-item" }
const _hoisted_5 = { class: "media-item" }
const _hoisted_6 = { class: "media-bottom" }

import { vReveal } from '@/directives/reveal'
import VideoPlayer from './VideoPlayer.vue'
import ImagePreview from './ImagePreview.vue'
import posterIntro from '@/assets/picture/Intro_labOS_first_frame.png'
import posterLabDemo from '@/assets/picture/Media_No3_Lab_Demo_Cover.png'
import introFigure from '@/assets/picture/intro_labOS_f1.png'

// 视频文件放在 public 目录，直接使用路径引用
const videoSrc1 = '/videos/Media_No1_LabOS_System_Intro.mov'
const videoSrc2 = '/videos/Media_No3_LabOS_Demo_Video.mp4'


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "section-title" }, "About LabOS", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "section-lead" }, " A self-evolving, multi-agent system paired with XR smart-glasses and a lab-specialized VLM to co-pilot experiments with human scientists and robotics. ", -1)),
      _createVNode(_component_a_row, {
        gutter: [28, 28],
        align: "stretch",
        class: "about-grid"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 12,
            class: "text-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_card, { class: "content-card" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "feature-block" }, [
                    _createElementVNode("h3", { class: "feature-title" }, "See"),
                    _createElementVNode("p", { class: "feature-text" }, " AR/XR smart‑glasses with real‑time multimodal sensing capture egocentric lab workflows. A lab‑specialized VLM, post‑trained on public and in‑house experimental videos and the LSV corpus, aligns live actions to reference protocols, detects deviations, verifies outcomes, and supports 3D/4D spatial \"digital twins\" for grounded scene understanding. ")
                  ], -1),
                  _createElementVNode("div", { class: "feature-block" }, [
                    _createElementVNode("h3", { class: "feature-title" }, "Reason"),
                    _createElementVNode("p", { class: "feature-text" }, " A self‑evolving multi‑agent core—Manager/Planner, Developer (coding & execution), Critic (evaluation & refinement)—with a Tool‑Creation module that auto‑expands a shared Tool Ocean for new analyses. Demonstrates state‑of‑the‑art performance on HLE: Biomedicine and LAB‑Bench (DBQA/LitQA). ")
                  ], -1),
                  _createElementVNode("div", { class: "feature-block" }, [
                    _createElementVNode("h3", { class: "feature-title" }, "Act"),
                    _createElementVNode("p", { class: "feature-text feature-text-last" }, " Streams protocol steps to XR for hands‑free, step‑by‑step guidance with error‑detection/correction cues and voice/gesture interaction. Records materials and steps for automated documentation, closing the loop from design to wet‑lab validation. ")
                  ], -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            lg: 12,
            class: "media-column"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(VideoPlayer, {
                    class: "media-video",
                    src: videoSrc1,
                    poster: _unref(posterIntro)
                  }, null, 8, ["poster"]),
                  _cache[1] || (_cache[1] = _createElementVNode("p", { class: "media-caption" }, "LabOS System Intro", -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(VideoPlayer, {
                    class: "media-video",
                    src: videoSrc2,
                    poster: _unref(posterLabDemo),
                    "cover-scale": 1.4
                  }, null, 8, ["poster"]),
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "media-caption" }, "LabOS: The Future of Agentic Lab Automation ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(ImagePreview, {
                  class: "media-image",
                  src: _unref(introFigure),
                  alt: "Intro Figure"
                }, null, 8, ["src"]),
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "media-caption" }, " LabOS overview", -1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])), [
      [_unref(vReveal)]
    ])
  ]))
}
}

})